export type Locale = 'id' | 'en';
export type Theme = 'light' | 'dark';

const LOCALE_KEY = 'bx_locale';
const THEME_KEY = 'bx_theme';

export function readLocale(): Locale {
  try {
    const raw = localStorage.getItem(LOCALE_KEY);
    if (raw === 'en' || raw === 'id') return raw;
  } catch {
    // ignore
  }
  return 'id';
}

export function writeLocale(locale: Locale) {
  localStorage.setItem(LOCALE_KEY, locale);
}

export function readTheme(): Theme {
  try {
    const raw = localStorage.getItem(THEME_KEY);
    if (raw === 'light' || raw === 'dark') return raw;
  } catch {
    // ignore
  }
  return 'light';
}

export function writeTheme(theme: Theme) {
  localStorage.setItem(THEME_KEY, theme);
}

export function applyThemeClass(theme: Theme) {
  const root = document.documentElement;
  if (theme === 'dark') root.classList.add('dark');
  else root.classList.remove('dark');
}
